<div *ngIf="magicLinkComplete" class="oidc-callback magic-complete">
  <div class="magic-complete-check" aria-hidden="true">✓</div>
  <h1 class="magic-complete-title">You're logged in</h1>
  <p class="oidc-callback-text">
    Return to the tab or device where you requested the login link — it's signing you in
    now. You can close this tab.
  </p>
  <button type="button" class="magic-complete-continue" (click)="continueHere()">
    Continue here instead
  </button>
</div>

<div *ngIf="!magicLinkComplete" class="oidc-callback">
  <p class="oidc-callback-text">Signing you in…</p>
  <div class="dots" aria-hidden="true">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</div>
